"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.path = exports.requestSchema = void 0;
const zod_1 = __importDefault(require("zod"));
exports.requestSchema = zod_1.default.object({
    zoneName: zod_1.default.string(),
    irrigationZoneId: zod_1.default.number(),
});
exports.path = '/irrigation-zone-update';
//# sourceMappingURL=index.js.map